function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: "#1f2513",
  d: "M480.987 237V100.4a100.38 100.38 0 11200.759 0V237H480.987z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: "#472b0d",
  d: "M480.9 385c.052-1.567.088-3.137.088-4.716V237.4a100.38 100.38 0 11200.759 0v142.884c0 1.576-.038 3.144-.059 4.716H480.9z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: "#a53504",
  d: "M596.927 605.1L444.959 474a139.615 139.615 0 0036.028-93.719v-.881a100.38 100.38 0 11200.759 0v.882A339.594 339.594 0 01596.927 605.1z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: "#e54101",
  d: "M591.787 611.189a101.065 101.065 0 01-6.456 6.439C523.346 681.372 436.668 721.25 340.875 721.25 152.916 721.25 0 568.291 0 380.284V100.4a100.379 100.379 0 11200.759 0v279.884c0 77.28 62.855 140.152 140.115 140.152a139.7 139.7 0 00101.343-43.482 100.489 100.489 0 11149.57 134.235z"
});

var SvgLogoRed = function SvgLogoRed(props) {
  return React.createElement("svg", _extends({
    width: 682,
    height: 722,
    viewBox: "0 0 682 722"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2ODIiIGhlaWdodD0iNzIyIiB2aWV3Qm94PSIwIDAgNjgyIDcyMiI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBmaWxsPSIjMWYyNTEzIiBkPSJNNDgwLjk4NywyMzdWMTAwLjRhMTAwLjM4LDEwMC4zOCwwLDEsMSwyMDAuNzU5LDBWMjM3SDQ4MC45ODdaIiAvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzQ3MmIwZCIgZD0iTTQ4MC45LDM4NWMwLjA1Mi0xLjU2Ny4wODgtMy4xMzcsMC4wODgtNC43MTZWMjM3LjRhMTAwLjM4LDEwMC4zOCwwLDEsMSwyMDAuNzU5LDBWMzgwLjI4NGMwLDEuNTc2LS4wMzgsMy4xNDQtMC4wNTksNC43MTZINDgwLjlaIiAvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI2E1MzUwNCIgZD0iTTU5Ni45MjcsNjA1LjFMNDQ0Ljk1OSw0NzRhMTM5LjYxNSwxMzkuNjE1LDAsMCwwLDM2LjAyOC05My43MTlWMzc5LjRhMTAwLjM4LDEwMC4zOCwwLDEsMSwyMDAuNzU5LDB2MC44ODJBMzM5LjU5NCwzMzkuNTk0LDAsMCwxLDU5Ni45MjcsNjA1LjFaIiAvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI2U1NDEwMSIgZD0iTTU5MS43ODcsNjExLjE4OWMtMi4wNDgsMi4yNDctNC4yMTMsNC4zODUtNi40NTYsNi40MzlDNTIzLjM0Niw2ODEuMzcyLDQzNi42NjgsNzIxLjI1LDM0MC44NzUsNzIxLjI1LDE1Mi45MTYsNzIxLjI1LDAsNTY4LjI5MSwwLDM4MC4yODRWMTAwLjRhMTAwLjM3OSwxMDAuMzc5LDAsMSwxLDIwMC43NTksMFYzODAuMjg0YzAsNzcuMjgsNjIuODU1LDE0MC4xNTIsMTQwLjExNSwxNDAuMTUyYTEzOS43LDEzOS43LDAsMCwwLDEwMS4zNDMtNDMuNDgyQTEwMC40ODksMTAwLjQ4OSwwLDEsMSw1OTEuNzg3LDYxMS4xODlaIiAvPgo8L3N2Zz4K";
export { SvgLogoRed as ReactComponent };